"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.standardUpdateSteps = void 0;
exports.createRules = createRules;
const lodash_1 = require("lodash");
const common_1 = require("../common");
const random_1 = require("../random");
const moves_1 = require("./moves");
const win_1 = require("./win");
// The standard step-consumption used by playTurnMoves for BOTH variants. This
// preserves the current behavior where playTurnMoves computes newSteps via the
// standard rule (roro.playTurnMoves historically called standardRules.updateSteps,
// not its own shesh-besh aware updateSteps).
const standardUpdateSteps = (_state, moves, steps) => {
    let newSteps = [...steps];
    moves.forEach((move) => {
        const si = newSteps.indexOf(move.step);
        newSteps = newSteps.filter((_, i) => i !== si);
    });
    return newSteps;
};
exports.standardUpdateSteps = standardUpdateSteps;
function createRules(parts) {
    const rules = Object.assign(Object.assign({ getInitialGameState: common_1.getInitialGameState }, parts), { playSingleMove: moves_1.applyValidatedMove, rollDice: sharedRollDice, playTurnMoves: (state, moves) => playTurnMoves(rules, state, moves), isGameOver: win_1.isGameOver,
        getGameOverState: win_1.getGameOverState });
    return rules;
}
function sharedRollDice(state) {
    if (!(0, lodash_1.isNil)(state.dice)) {
        throw new Error('Dice already rolled');
    }
    return Object.assign(Object.assign({}, state), { dice: (0, random_1.rollDice)() });
}
function playTurnMoves(rules, state, moves) {
    const steps = (0, common_1.diceToSteps)(state.dice);
    const expectedMoves = steps.length;
    if (moves.length > expectedMoves) {
        throw new Error('Too many moves');
    }
    const newState = moves.reduce((s, move) => rules.playSingleMove(s, move), state);
    const newSteps = (0, exports.standardUpdateSteps)(state, moves, steps);
    if (moves.length < expectedMoves) {
        const availableMoves = rules.getMovesWithSteps(newState, newSteps);
        if (Object.keys(availableMoves).length > 0) {
            throw new Error('Not all moves were made');
        }
    }
    return newState;
}
